module.exports = __webpack_public_path__ + "static/Slide2-382bdf5a41b1595b14c21def1582858a.jpg";